import React, { useMemo } from "react";
import CollapsibleTable from "../../components/CommonComponents/CollapsibleTable/index";
import { createFavData } from "./Datafunctions";
import { Box } from "@mui/material";
import NoDataFound from "../PrivateDashboard/NoDataFound";
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import StyledFavItems from "./StyledFavItems";
import wanderobelogo from "../../assets/images/wanderobe-logo-1.svg";

const FavItems = ({ favData, loading, setPageNo, setPageSize, pageSize, pageNo, pageInfo, loaderHeight, sxHeight, showPagination = true, className = "text-truncate", sxMobileHeight = "auto" }) => {
  const heading = ["Product Name", "Price", "Favorited By"];

  const invoiceRows = useMemo(() => favData?.map(item =>
    createFavData(<Box className="product-container">
      <Box component="img"
        className="image-product"
        src={item?.image?.[0] || wanderobelogo}
        alt={item?.name.substring(0, 10)}
      /> <span className={className}>{item?.name}</span></Box>, `$${item?.price}`, item?.favorites_count)
  ) || [],
    // eslint-disable-next-line
    [favData]);

  return (
    <StyledFavItems>
      <Box sx={{ display: { xs: "block" }, height: `calc(${(loaderHeight)} + 34px)` }}>
        {!loading && favData?.length === 0 ?
          <NoDataFound
            icon={<FavoriteBorderOutlinedIcon className="icon-no-data" />}
            heading="No Favorites from Buyers"
            subHeading="Keep adding trendy styles—buyers will start saving them soon!"
          />
          :
          <CollapsibleTable
            loading={loading}
            showPagination={showPagination}
            sxHeight={sxHeight}
            sxMobileHeight={sxMobileHeight}
            pageNo={pageNo}
            pageSize={pageInfo?.total_count >= 10 ? pageSize : pageInfo?.total_count}
            setPageNo={setPageNo}
            setPageSize={setPageSize}
            headings={heading}
            rows={invoiceRows}
            isDownIconVisible={false}
            totalCount={pageInfo?.total_count}
            totalPages={pageInfo?.total_pages}
          />}

      </Box>

    </StyledFavItems>
  );
};

export default FavItems;

